import React, { CSSProperties } from 'react'

import styled from '@emotion/styled'

import { component as arcadeComponentColors, semantic as arcadeSemanticColors } from '@arcade/web'

import { colors, typography } from '../../theme'

const isSemanticColor = (color: string): color is keyof typeof arcadeSemanticColors => {
  return color in arcadeSemanticColors
}

const isArcadeComponentColor = (color: string): color is keyof typeof arcadeComponentColors => {
  return color in arcadeComponentColors
}

const isMooncakeColor = (color: string): color is keyof typeof colors => {
  return color in colors
}

export type TextThemeColors =
  | keyof typeof colors
  | keyof typeof arcadeSemanticColors
  | keyof typeof arcadeComponentColors

const TextBase = styled.span<{
  themeColor?: TextThemeColors
  typography?: keyof typeof typography
  textAlign?: CSSProperties['textAlign']
}>`
  ${({ theme, themeColor }) => {
    if (!themeColor) return ''

    if (isSemanticColor(themeColor)) {
      return `color: ${theme.arcadeColors.semantic[themeColor]};`
    }
    if (isArcadeComponentColor(themeColor)) {
      return `color: ${theme.arcadeColors.component[themeColor]};`
    }
    if (isMooncakeColor(themeColor)) {
      return `color: ${theme.colors[themeColor]};`
    }
    return ''
  }}
  ${({ theme, typography }) => (typography ? theme.typography[typography] : '')}
  ${({ textAlign }) => (textAlign ? `text-align: ${textAlign};` : '')}
`

// Wraps the TextBase since if we pass a `color` attribute directly to a styled component
// it will show up as an attribute in the DOM.
const Text = ({
  color,
  ...rest
}: Omit<React.ComponentProps<typeof TextBase>, 'themeColor'> & {
  color?: React.ComponentProps<typeof TextBase>['themeColor']
}) => {
  return <TextBase themeColor={color} {...rest} />
}

export default Text
